import React, { useEffect, useState, useLayoutEffect } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Container, Offcanvas, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { LoginManager } from '../../../core/login-manager';
import avatars from '../../../core/avatar';
import logo from '../../../assets/logo.svg';
import { DataManager } from '../../../core/data-manager';


export default function HeaderBlock(props) {

    const [userInfo, setUserInfo] = useState(null);
    const [cart, setCart] = useState(0);
    const [dropVisible, setDropVisible] = useState(false);
    const [modal, setModal] = useState(false);


    let location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        console.log('location: ', location)
        var element = document.getElementById("app-container");
        element.setAttribute("data-page", location.pathname);
    }, [location]);


    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);

        var headerOffcanvas = document.getElementById("responsive-header-navbar");
        if (headerOffcanvas.classList.contains('show')) {
            console.log('closing menu')
            var closeBtn = document.querySelector("#responsive-header-navbar .offcanvas-header .btn-close");
            closeBtn.click()
        }
    }, [location.pathname]);


    useEffect(() => {
        async function init() {
            var u = LoginManager.getUserInfo()
            setUserInfo(u)
            console.log(u)
        }
        init()
    }, []);

    async function handleReservedAreaClick(e) {
        e.preventDefault();
        const loggedIn = await LoginManager.checkLogin();
        navigate(loggedIn ? '/profile' : '/login');
    }




    return (
        <>
            <Navbar expand="lg" collapseOnSelect sticky="top" id="header-navbar" className='bg-white py-3 px-3 border-bottom'>
                <Container fluid={'md'}>
                    <Navbar.Brand>
                        <Link to='/'>
                            <Image src={logo} height={40} alt='Cimolai' />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-header-navbar" />

                    <Navbar.Offcanvas id="responsive-header-navbar" placement="end" className='text-secondary'>
                        <Offcanvas.Header closeButton>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            {/* Centered navigation */}
                            <Nav className="mx-auto text-center" id="header-menu">
                                <Nav.Link
                                    as={NavLink}
                                    to="/"
                                    end
                                    style={({ isActive }) => ({
                                        color: '#0A2B5E',
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.5,
                                        fontWeight: isActive ? 600 : 300
                                    })}
                                >
                                    {LanguageProvider.get('headerTexts.explore')}
                                </Nav.Link>
                                <Nav.Link
                                    onClick={handleReservedAreaClick}
                                    style={{
                                        color: '#0A2B5E',
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.5,
                                        fontWeight: (location.pathname.startsWith('/profile') || location.pathname.startsWith('/login')) ? 600 : 300
                                    }}
                                >
                                    {LanguageProvider.get('headerTexts.reserved')}
                                </Nav.Link>
                            </Nav>

                            {/* Language selector on the right */}
                            <Nav className='ms-lg-3 justify-content-center'>
                                <NavDropdown
                                    align='end'
                                    title={<span style={{ color: '#0A2B5E', textTransform: 'uppercase' }}>{(props.language === 'eng' ? 'EN' : 'IT')}</span>}
                                    id='lang-dropdown'
                                >
                                    <NavDropdown.Item onClick={() => props.onChangeLanguage && props.onChangeLanguage('ita')}>IT</NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => props.onChangeLanguage && props.onChangeLanguage('eng')}>EN</NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>

                </Container>
            </Navbar>
        </>
    );
};
